export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./general.vue?vue&type=template&id=066545c9"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/general.vue?vue&type=template&id=066545c9
// module id = rivy
// module chunks = 0